import { useUserManagementServiceV1 } from "@rw1/api-services";
import { UserManagement_V1 } from "@rw1/auto-generated-clients";
import { useMemo } from "react";
import { STALE_TIME_MS } from "./constants";
import { useFetchAll } from "./useFetchAll";

export const USER_GROUPS_QUERY_KEY = "userGroups";

interface UseAllUserGroupsForACompanyResult {
  groups: UserManagement_V1.UserGroup[];
  isLoading: boolean;
  error: Error | null;
}

export const useAllUserGroupsForACompany = (
  companyId?: string,
  enabled?: boolean
): UseAllUserGroupsForACompanyResult => {
  const userManagementClient = useUserManagementServiceV1();

  const {
    data: groups,
    isLoading,
    error,
  } = useFetchAll<UserManagement_V1.UserGroup>(
    [USER_GROUPS_QUERY_KEY, companyId],
    (page, size) =>
      userManagementClient.getAllUserGroupsForCompany(
        companyId!,
        page,
        size,
        undefined,
      ),
    {
      enabled: !!enabled && !!companyId,
      staleTime: STALE_TIME_MS,
    },
  );

  return useMemo(
    () => ({
      groups: groups ?? [],
      isLoading: isLoading || (!!companyId && groups === undefined && !error),
      error,
    }),
    [groups, isLoading, error, companyId],
  );
};
